<app-header [title]="title" [subtitle]="subtitle"></app-header>
<article class="choose-project">
    <main>
      <div class="row">
        <div class="col- col-md-6 col-xs-12 item">
          <a routerLink="/palettes-info/0" class="zoomin" (mouseover)="onTypeSelect(1)" (mouseout)="onTypeSelect(0)"
             [ngClass]="{'inactive': typeSelected != 0 && typeSelected != 1}">
            <div class="view overlay zoom">
              <img src="assets/domy/dom1_miejski_szyk.jpg" class="img-fluid " alt="smaple image">
              <div class="mask flex-center">
                <button   class="btn btn-success leaning strong  nav-button nav-button-next btn-border-rev clearfix">Dalej</button>
              </div>
            </div>
          </a>
        </div>
        <div class="col- col-md-6 col-xs-12 item">
          <a routerLink="/palettes-info/1" class="zoomin" (mouseover)="onTypeSelect(2)" (mouseout)="onTypeSelect(0)"
             [ngClass]="{'inactive': typeSelected != 0 && typeSelected != 2}">
            <div class="view overlay zoom">
              <img src="assets/domy/dom2_klasyczna_elegancja.jpg" class="img-fluid " alt="smaple image">
              <div class="mask flex-center">
                <button class="btn btn-success">Dalej</button>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col- col-md-6 col-xs-12 item">
          <a routerLink="/palettes-info/2" class="zoomin" (mouseover)="onTypeSelect(3)" (mouseout)="onTypeSelect(0)"
             [ngClass]="{'inactive': typeSelected != 0 && typeSelected != 3}">

            <div class="view overlay zoom">
              <img src="assets/domy/dom3_miejski_szyk.jpg" class="img-fluid " alt="smaple image">
              <div class="mask flex-center">
                <button class="btn btn-success">Dalej</button>
              </div>
            </div>
          </a>
        </div>
        <div class="col- col-md-6 col-xs-12 item">
          <a routerLink="/palettes-info/3" class="zoomin" (mouseover)="onTypeSelect(4)" (mouseout)="onTypeSelect(0)"
             [ngClass]="{'inactive': typeSelected != 0 && typeSelected != 4}">

            <div class="view overlay zoom">
              <img src="assets/domy/dom4_w_zgodzie_z_natura.jpg" class="img-fluid " alt="smaple image">
              <div class="mask flex-center">
                <button class="btn btn-success">Dalej</button>
              </div>
            </div>

          </a>
        </div>
      </div>

    </main>
</article>
